import React, { useEffect, useState, useCallback } from "react"
import { getQuiz, getRecommendation, analyzeQuizResults } from '../../api/Api'
import { QuizWrapp } from "./Quiz.style"
import ReactLoading from 'react-loading'
import { useNavigate } from "react-router-dom"

const Quiz = () => {
  const [quiz, setQuiz] = useState()
  const [openButton, setOpenButton] = useState(false)
  const [openResult, setOpenResult] = useState(false)
  const [lastIdQuiz, setLastIdQuiz] = useState()
  const [recommendation, setRecommendation] = useState()
  const [answerPath, setAnswerPath] = useState([])
  const [isAnalyzing, setIsAnalyzing] = useState(false)
  const [req, setReq] = useState({
    id: 0,
    isLast: false
  })
  const navigate = useNavigate()

  useEffect(() => {
    if (!req.isLast) {
      getQuiz(req)
        .then(res => res.json())
        .then(res => setQuiz(res))
        .catch(err => console.error('Error fetching quiz:', err))
    } else {
      setOpenButton(true)
    }
  }, [req])

  const handleClickQuiz = useCallback((idQuiz, isLast) => {
    setAnswerPath(prev => [...prev, idQuiz])
    if (isLast === true) {
      setLastIdQuiz(idQuiz)
    }
    setReq({ id: idQuiz, isLast: isLast })
  }, [])

  const result = async () => {
    setIsAnalyzing(true)
    setOpenResult(true)
    
    try {
      // First try AI-enhanced analysis
      const aiResult = await analyzeQuizResults(answerPath, lastIdQuiz)
      const aiData = await aiResult.json()
      setRecommendation(aiData)
    } catch (error) {
      console.error('AI analysis failed, using basic recommendation:', error)
      // Fallback to basic quiz result
      try {
        const basicResult = await getQuiz({ id: lastIdQuiz, isLast: true })
        const basicData = await basicResult.json()
        setRecommendation(basicData)
      } catch (fallbackError) {
        console.error('Failed to get recommendation:', fallbackError)
        setRecommendation({
          RecommendationRole: "Career path analysis unavailable",
          RecomendationHardSkills: ["Please try again later"]
        })
      }
    } finally {
      setIsAnalyzing(false)
    }
  }

  const getRecommend = (role) => {
    getRecommendation(role)
      .then(res => res.json())
      .then(res => navigate(`/lowongan`, { state: { res } }))
      .catch(err => {
        console.error('Error getting recommendations:', err)
        navigate('/lowongan')
      })
  }

  const restartQuiz = () => {
    setQuiz(null)
    setOpenButton(false)
    setOpenResult(false)
    setLastIdQuiz(null)
    setRecommendation(null)
    setAnswerPath([])
    setReq({ id: 0, isLast: false })
  }

  return (
    <QuizWrapp>
      <div className="container">
        <div className="quiz">
          <div className="content">
            {openResult ? (
              <>
                {isAnalyzing || !recommendation ? (
                  <div className="spin-load">
                    <p className="analyzing-text">Analyzing your answers with AI...</p>
                    <ReactLoading className="center" type="bubbles" color="#5f7967" height={44} width={44} />
                  </div>
                ) : (
                  <div className="recommend">
                    <div className="result-header">
                      <h2>Your Career Match</h2>
                    </div>
                    <div className="result-card">
                      <p className="subtitle">Based on your answers, this career suits you:</p>
                      <h3 className="rec_role">{recommendation.RecommendationRole}</h3>
                      
                      {recommendation.Description && (
                        <p className="description">{recommendation.Description}</p>
                      )}
                      
                      {recommendation.WhyThisCareer && (
                        <div className="why-section">
                          <h4>Why This Career?</h4>
                          <p>{recommendation.WhyThisCareer}</p>
                        </div>
                      )}
                      
                      <div className="skills-section">
                        <h4>Skills to Master:</h4>
                        <div className="skills-list">
                          {recommendation.RecomendationHardSkills?.map((skill, index) => (
                            <span key={index} className="skill-tag">{skill}</span>
                          ))}
                        </div>
                      </div>
                      
                      {recommendation.LearningPath && (
                        <div className="learning-path">
                          <h4>Learning Path:</h4>
                          <ol>
                            {(Array.isArray(recommendation.LearningPath) 
                              ? recommendation.LearningPath 
                              : [recommendation.LearningPath]
                            ).map((step, index) => (
                              <li key={index}>{step}</li>
                            ))}
                          </ol>
                        </div>
                      )}
                      
                      {recommendation.GrowthPotential && (
                        <div className="growth-section">
                          <h4>Growth Potential:</h4>
                          <p>{recommendation.GrowthPotential}</p>
                        </div>
                      )}
                      
                      {recommendation.AverageInternSalary && (
                        <div className="salary-section">
                          <h4>Expected Internship Salary:</h4>
                          <p className="salary">{recommendation.AverageInternSalary}</p>
                        </div>
                      )}
                    </div>
                    
                    <div className="action-buttons">
                      <button className="btn-rec primary" onClick={() => getRecommend(recommendation.RecommendationRole)}>
                        View Matching Internships
                      </button>
                      <button className="btn-rec secondary" onClick={restartQuiz}>
                        Retake Quiz
                      </button>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="progress-indicator">
                  <span>Question {answerPath.length + 1}</span>
                </div>
                <h1 className="question">{quiz?.Question}</h1>
                <div className="answers">
                  <ul>
                    {!quiz ? (
                      <div className="spin-load">
                        <ReactLoading className="center" type="bubbles" color="#5f7967" height={44} width={44} />
                      </div>
                    ) : (
                      quiz?.Options?.map((res, index) => (
                        <li 
                          key={res.Id || index} 
                          className="answer" 
                          onClick={() => handleClickQuiz(res.Id, quiz.IsLast)}
                        >
                          <span className="answer-number">{index + 1}</span>
                          {res.Text}
                        </li>
                      ))
                    )}
                  </ul>
                  {openButton && (
                    <div className="result">
                      <button className="btn-result" onClick={result}>
                        View Results
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </QuizWrapp>
  )
}

export default Quiz
